import { setCoinsApplied, setCoinsEntered } from '../../actions/Loyalty';
import { store } from '../../Store';

let rateCodePrimeroSeleccionado = null;
let boardCodePrimeroSeleccionado = null;

export const getRealCoinsUsedInUsdOrEur = (props) => {
  const totalCoins = {
    loyaltyCoins: 0,
    coinsNewMemberDiscount: 0,
  };
  if (props.new_member === true && props.new_member_discount_percentage_activated === true) {
    const total = props.coinsApplied;
    const coinsNewMemberDiscountPercentage = getNewMemberDiscountCoinsPerRoomAsInBackend(props).total;
    //Acá debemos calcular el descuento de coins por cuarto y no por total de la booking porque así se hace en el backend
    //sino podrá pasar que tengamos un coin de más en el front
    totalCoins.loyaltyCoins = total - coinsNewMemberDiscountPercentage;
    totalCoins.coinsNewMemberDiscount = coinsNewMemberDiscountPercentage;
    return totalCoins;
  }

  totalCoins.loyaltyCoins = props.coinsApplied;
  totalCoins.coinsNewMemberDiscount = 0;

  return totalCoins;
};

export const getLowerLimit2 = (props) => {
  //funciona para muchas coins
  let lowerLimit = 0;
  if (props.new_member === true && props.new_member_discount_percentage_activated === true) {
    lowerLimit = props.maxCoinsToApply - (Math.round(FinalRoomsAmount(props).totalAmount
      * (props.maxPercentUsage / 100)));
  }
  return lowerLimit;
};

export const getUpperLimit2 = (props) => {
  let upperLimit = props.maxCoinsToApply;
  if (props.new_member === true && props.new_member_discount_percentage_activated === true) {
    upperLimit = FinalRoomsAmount(props).totalAmount * (props.maxPercentUsage / 100)
      + (Math.round(FinalRoomsAmount(props).totalAmount * (props.maxPercentUsage / 100)));
  }
  if (upperLimit >= props.maxCoinsToApply) {
    return props.maxCoinsToApply;
  }
  return Math.round(upperLimit);
};

export const getLowerLimit = (props) => {
  let lowerLimit = 0;
  if (props.new_member === true && props.new_member_discount_percentage_activated === true) {
    lowerLimit = props.maxCoinsToApply - (getCoinsMaximosATomarEnCuenta(props));
  }
  return lowerLimit;
};

export const bookingIsCoveredWithLoyaltyCoins = (props) => {
  const result = {
    bookingIsCovered: false,
    amountToPayInSelectedCurrency: 0,
  };
  if (props.hotel == null) {
    return result;
  }
  if (props.conversionRates == null) {
    return result;
  }
  const finalCoinsApplied = (props.isEditingBooking || window.location.pathname === '/thanks/'
      || window.location.pathname === '/booking-detail/')
    ? props.coinsUsedInEditingBooking : props.coinsApplied;
  let bookingIsCovered = false;
  let currency_code_to_use = '';
  if (props.isCallCenterUser === true) {
    currency_code_to_use = props.hotel.rooms.FREE_MODE[0].rates[0].currency;
  } else if (props.cart.budget_token) {
    currency_code_to_use = props.hotel.rooms[0].rate.currency_code;
  } else {
    currency_code_to_use = props.hotel.rooms['1'][0].rates[0].currency;
  }
  const customCurrency = props.currencies.find((element) => element.code === currency_code_to_use);
  const finalCoinsAppliedInBookingCurrency = convertCoinsToCurrencyUsingRoundedConversionRate(props,
    finalCoinsApplied,
    customCurrency);
  //const currency_code_to_use = currency.code;
  const priceWithoutExtras = FinalRoomsAmount(props, currency_code_to_use, false).totalAmount;
  //- FinalRoomsAmount(props, currency_code_to_use, false).totalTaxes;
  // REVERT SI SE NECESITA CALCULAR MEMBER RATE Y SA NET RATE TOMANDO EN CUENTA EL COSTO DE LA RESERVA
  // SIN IMPUESTOS. AHROTIA LO TUVIMOS QUE DEJAR COMO ANTES, CALCULANDO EL MEMBER RATE Y SA NET RATE TOMANDO
  // EL COSTO TOTAL DE LA RESERVA CON IMPUESTOS
  // Le tuvimos que quitar lo de arriba, si se necesita después que el member rate se calcule con base en el costo
  // de la reserva sin impuestos, descomentar esa parte
  const price = FinalRoomsAmount(props, currency_code_to_use, false).totalAmount
    + FinalRoomsAmount(props, currency_code_to_use, false).totalAmountExtras;
  let discountSandos4U = 0;
  // Comprobar si se cumplen todas las condiciones
  const isEligibleForDiscount = props.isLoyaltyUserLoggedIn
    && props.new_member_discount_percentage_activated && props.new_member;
  if (isEligibleForDiscount === true) {
    discountSandos4U = priceWithoutExtras * (props.new_member_discount_percentage / 100);
  }
  const priceToPay = (price - discountSandos4U);
  if (finalCoinsAppliedInBookingCurrency >= priceToPay) {
    bookingIsCovered = true;
  }
  result.bookingIsCovered = bookingIsCovered;
  const resta = priceToPay - (isEligibleForDiscount ? finalCoinsAppliedInBookingCurrency : 0);
  let restaConverted = 0;
  if (currency_code_to_use !== props.currency.code) {
    // OJO: Antes hacíamos convertirMoneda(props, priceToPay, currency_code_to_use, props.currency.code),
    // es decir, reconvertíamos el precio (ya calculado y redondeado en currency_code_to_use, p.ej. USD)
    // de vuelta a la moneda seleccionada por el usuario (p.ej. MXN). Eso provocaba un doble redondeo:
    // el monto exacto en MXN (guardado en el carrito) se veía primero redondeado a USD y luego, al
    // reconvertirlo a MXN, salía con centavos de más (ej. 100 MXN -> 100.02 MXN). Para evitarlo,
    // calculamos el precio directamente en la moneda seleccionada usando los montos ya precisos que
    // trae el carrito para esa moneda (los mismos que usa el bloque "Room 01"), en vez de reconvertir.
    const priceWithoutExtrasInSelectedCurrency = FinalRoomsAmount(props, props.currency.code, false).totalAmount;
    const priceInSelectedCurrency = priceWithoutExtrasInSelectedCurrency
      + FinalRoomsAmount(props, props.currency.code, false).totalAmountExtras;
    const discountSandos4UInSelectedCurrency = isEligibleForDiscount
      ? priceWithoutExtrasInSelectedCurrency * (props.new_member_discount_percentage / 100) : 0;
    const priceToPayInSelectedCurrency = priceInSelectedCurrency - discountSandos4UInSelectedCurrency;
    restaConverted = priceToPayInSelectedCurrency;
    restaConverted -= (isEligibleForDiscount
      ? convertCoinsToCurrencyUsingRoundedConversionRate(props, finalCoinsApplied, props.currency) : 0);
  } else {
    restaConverted = resta;
  }
  if (restaConverted < 0) {
    restaConverted = 0;
  }
  result.amountToPayInSelectedCurrency = restaConverted;
  return result;
};

export const getCoinsMaximosATomarEnCuenta = (props) => {
  if (props.memberInfo == null) {
    return 0;
  }
  let coinsATomarEnCuenta = 0;
  // El currency_code a usar es el que se usa en los rates de la booking, es decir, de como viene de dingus la reserva
  let currency_code_to_use_booking = '';
  if (props.isCallCenterUser === true) {
    currency_code_to_use_booking = props.hotel.rooms.FREE_MODE[0].rates[0].currency;
  } else {
    currency_code_to_use_booking = props.hotel.rooms['1'][0].rates[0].currency;
  }

  const price = FinalRoomsAmount(props, currency_code_to_use_booking, false).totalAmount;
  const discountSandos4U = price * (props.new_member_discount_percentage / 100);

  const currency_to_use_hotel = props.hotel.city.zone.country.iso_code === 'MX' ? 'USD' : 'EUR';
  const priceInConvertedValueUsdOrEur = convertirMoneda(
    props,
    (price - discountSandos4U),
    currency_code_to_use_booking,
    currency_to_use_hotel,
  ); //Este precio está en USD y es la cantidad que debería cubrirse con coins

  //No se pueden tomar en cuenta todos los coins, sino sólo hasta la cantidad máxima permitida según el maxDiscounPercentage

  if (props.memberInfo.availableCoins > (Math.round(priceInConvertedValueUsdOrEur * (props.maxPercentUsage / 100)))) {
    coinsATomarEnCuenta = (Math.round(priceInConvertedValueUsdOrEur * (props.maxPercentUsage / 100)));

    if ((props.maxPercentUsage / 100) === 1) {
      if (coinsATomarEnCuenta < priceInConvertedValueUsdOrEur) {
        coinsATomarEnCuenta += 1;
        // Pasa que cuando el precio de la reserva termina con centavos, en caso de que se quiera
        // redimir el 100% del costo de la estancia, es necesario agregar un coin más al final porque
        // si no se tendrá que pagar esos centavos restantes en metapasarela
      }
    }
  } else {
    coinsATomarEnCuenta = props.memberInfo.availableCoins;
  }
  return coinsATomarEnCuenta;
};

export const getUpperLimit = (props) => {
  // Pidieron que cuando agentSell sea true, que no se permita usar coins
  if (props.agentCode !== '' && props.agentSell === 'true') {
    return 0;
  }
  const coinsATomarEnCuenta = getCoinsMaximosATomarEnCuenta(props);
  return Math.round(coinsATomarEnCuenta);
};

export const convertCoinsToCurrencyUsingRoundedConversionRate = (props, coins, currency = null) => {
  const state = store.getState();
  const force_conversion_1_eur_or_1_usd_equals_20_mxn_enabled = state.session.chainData.booking_engine_configuration
    .force_loyalty_coins_conversion_rates_to_1_eur_or_1_usd_equals_20_mxn_enabled;
  // Es igual al método convertCoinsToCurrency pero regresa el resultado redondeado
  // eso lo usamos para redondear el loyalty discount to apply porque en el backend
  // está a dos decimales, entonces para que coincidan los cálculos
  let finalCurrency = currency;
  if (!coins) {
    return 0;
  }
  if (finalCurrency == null) {
    // Tuvimos que agregar al método convertCoinsToCurrency el parámetro opcional currency, ya que
    // va al store y toma el currency de state.booking.filterCurrency, lo cual no coincidiría
    // con el currency que se toma de la ip del usuario
    finalCurrency = props.currency;
  }
  const conversionRate = props.conversionRates.find((element) => element.currency_code === finalCurrency.code);
  //force_loyalty_coins_conversion_rates_to_1_eur_or_1_usd_equals_20_mxn_enabled
  let conversionRateValue = conversionRate !== undefined ? conversionRate.value : 1;
  if (force_conversion_1_eur_or_1_usd_equals_20_mxn_enabled === true) {
    if (finalCurrency.code === 'EUR' || finalCurrency.code === 'USD') {
      conversionRateValue = 1;
    } else if (finalCurrency.code === 'MXN') {
      conversionRateValue = 20;
    } else if (conversionRate !== undefined) {
      conversionRateValue = conversionRate.value;
    } else {
      conversionRateValue = 1; // Valor por defecto
    }
  }
  const result = coins * conversionRateValue;
  const roundedResult = Math.round(result * 100) / 100; // 123.46 Usar así para redondear a dos decimales
  return roundedResult;
};

export const convertirMoneda = (props, cantidad, currency_code_from, currency_code_to) => {
  //ejemplo de uso: const resultado = convertirMoneda(props, 9.53, "MXN", "USD"); Ahí convertiría 9.53 MXN a USD, bueno, de hecho
  // puede convertir de cualquier moneda a cualquier moneda, primero convienrte a USD porque todos los valores de props.conversionRates están referenciados a USD
  const origen = props.conversionRates.find((rate) => rate.currency_code === currency_code_from);
  const destino = props.conversionRates.find((rate) => rate.currency_code === currency_code_to);

  if (!origen || !destino) {
    throw new Error('Código de moneda no válido.');
  }

  // Convertir primero a USD (asumiendo que todos los valores están referenciados a USD)
  const cantidadEnUSD = cantidad / origen.value;

  // Luego convertir de USD a moneda destino
  const cantidadConvertida = cantidadEnUSD * destino.value;

  return Math.round(cantidadConvertida * 100) / 100; // 123.46 Usar así para redondear a dos decimales
};

//cuando coins disponibles sean menor al costo de la booking
export const incrementCoins = (props) => {
  const upperLimit = getUpperLimit(props);
  if (props.enteredCoins < upperLimit) {
    props.dispatch(
      setCoinsEntered(props.enteredCoins + 1));
    props.dispatch(
      setCoinsApplied(props.enteredCoins + 1));
    return true;
  }
  return false;
};

export const validateSetCoinsManually = (props, inputValue) => {
  const upperLimit = getUpperLimit(props);
  const lowerLimit = getLowerLimit(props);
  let newValue = inputValue;
  if (newValue > lowerLimit && newValue < upperLimit) {
    newValue = inputValue;
  }
  if (newValue < lowerLimit) {
    newValue = lowerLimit;
  }
  if (newValue > upperLimit) {
    newValue = upperLimit;
  }
  return newValue;
};

export const decrementCoins = (props) => {
  const lowerLimit = getLowerLimit(props) > 0
    ? getLowerLimit(props) : 0;
  // Hacemos que el lowerLimit no pueda ser menor que 0 para que funcione para los dos
  // escenarios, cuando es un usuario normal con pocos coins y para cuando tiene demasiados coins
  if (props.enteredCoins > lowerLimit) {
    props.dispatch(
      setCoinsEntered(props.enteredCoins - 1));
    props.dispatch(
      setCoinsApplied(props.enteredCoins - 1));
    return true;
  }
  return false;
};

export const getTotalAmountsOfSelectedRoomsInUsdOrEur = (props) => {
  //ToDo
  //Actualmente para determinar cuantos coins deben darse usamos el amount en USD
  //Para hoteles de españa, meter el fix para que sea en euros
  const roomData = props.multipleRoomSelection;
  const totalAmounts = {
    totalAmount: 0,
    totalAmountBefore: 0,
  };
  //let totalExtras = 0;
  const currency_to_use = props.hotel.city.zone.country.iso_code === 'MX' ? 'USD' : 'EUR';

  if (roomData['1'] != null) {
    Object.keys(roomData).filter((key) => !Number.isNaN(Number(key))).forEach((key) => {
      if (roomData[key] != null) {
        /*let totalRoomExtras = 0;
        if (props.mostrarExtras === true) {
          totalRoomExtras = getTotalAmountExtras(props, key, currency_to_use);
          totalExtras += totalRoomExtras;
        }*/
        const { rates } = roomData[key].room; // Accediendo a los rates del primer cuarto seleccionado
        for (let i = 0; i < rates.length; i++) {
          if (rates[i].code === rateCodePrimeroSeleccionado) {
            const { boards } = rates[i];
            for (let j = 0; j < boards.length; j++) {
              if (boards[j].code === boardCodePrimeroSeleccionado) {
                totalAmounts.totalAmount += props.hotel.city.zone.country.iso_code === 'MX'
                  ? boards[j].amount.USD.amount : boards[j].amount.EUR.amount;
                totalAmounts.totalAmountBefore += props.hotel.city.zone.country.iso_code === 'MX'
                  ? boards[j].amount.USD.amount_before : boards[j].amount.EUR.amount_before;
                break;
              }
            }
            break;
          }
        }
      }
    });
  } else {
    const { rooms } = props.cart.cartHotel;
    // eslint-disable-next-line no-unused-vars
    rooms.forEach((room, index) => {
      /*let totalRoomExtras = 0;
      totalRoomExtras = getTotalAmountExtras(props, index + 1, currency_to_use);
      totalExtras += totalRoomExtras;*/
      totalAmounts.totalAmount += Math.round(room.amount[currency_to_use] * 100) / 100;
      totalAmounts.totalAmountBefore += Math.round(room.amount_before[currency_to_use] * 100) / 100;
    });
  }
  //totalAmounts.totalAmount += totalExtras;
  //totalAmounts.totalAmountBefore += totalExtras;
  totalAmounts.totalAmount = Math.round(totalAmounts.totalAmount * 100) / 100;
  totalAmounts.totalAmountBefore = Math.round(totalAmounts.totalAmountBefore * 100) / 100;
  return totalAmounts;
};

export const getNewMemberDiscountCoinsPerRoomAsInBackend = (props) => {
  //ToDo
  //Actualmente para determinar cuantos coins deben darse usamos el amount en USD
  //Para hoteles de españa, meter el fix para que sea en euros
  const roomData = props.multipleRoomSelection;
  const totalNewMemberDiscountCoindPerRoomAsInBackend = {
    total: 0,
  };
  //let totalExtras = 0; //Ponerle como let para después asignarle valor al calcular los extras

  if (roomData['1'] != null) {
    Object.keys(roomData).filter((key) => !Number.isNaN(Number(key))).forEach((key) => {
      if (roomData[key] != null) {
        /*let totalRoomExtras = 0;
        if (props.mostrarExtras === true) {
          totalRoomExtras = getTotalAmountExtras(props, key);
          totalExtras += totalRoomExtras;
        }*/
        const { rates } = roomData[key].room; // Accediendo a los rates del primer cuarto seleccionado
        for (let i = 0; i < rates.length; i++) {
          if (rates[i].code === rateCodePrimeroSeleccionado) {
            const { boards } = rates[i];
            for (let j = 0; j < boards.length; j++) {
              if (boards[j].code === boardCodePrimeroSeleccionado) {
                totalNewMemberDiscountCoindPerRoomAsInBackend.total += props.hotel.city.zone.country.iso_code === 'MX'
                  ? Math.round(boards[j].amount.USD.amount * (props.new_member_discount_percentage / 100))
                  : Math.round(boards[j].amount.EUR.amount * (props.new_member_discount_percentage / 100));
                break;
              }
            }
            break;
          }
        }
      }
    });
  } else {
    const { rooms } = props.cart.cartHotel;
    /*rooms.forEach((room, index) => {
      let totalRoomExtras = 0;
      totalRoomExtras = getTotalAmountExtras(props, index + 1);
      totalExtras += totalRoomExtras;
      totalAmounts.totalAmount += room.amount[props.currency.code];
      totalAmounts.totalAmountBefore += room.amount_before[props.currency.code];
    });*/
    rooms.forEach((room) => {
      totalNewMemberDiscountCoindPerRoomAsInBackend.total += props.hotel.city.zone.country.iso_code === 'MX'
        ? Math.round(room.amount.USD * (props.new_member_discount_percentage / 100))
        : Math.round(room.amount.EUR * (props.new_member_discount_percentage / 100));
    });
  }

  //totalAmounts.totalAmount += totalExtras;
  //totalAmounts.totalAmountBefore += totalExtras;
  //En este método no tomamos en cuenta los extras porque se usa para calcular el descuento del member rate
  //y en el primer paso donde no hay cart no tenemos extras, entonces el cálculo del descuento se hace
  //con base en el costo de la booking sin tomar en cuenta los extras, al final los extras se agregan
  //como algo extra a cobrar
  return totalNewMemberDiscountCoindPerRoomAsInBackend;
};

export const isNewCartEmpty = (props) => {
  const { rooms } = props.cart.cartHotel;
  const roomData = props.multipleRoomSelection;
  let cartDataEmpty = true;
  let multipleRoomSelectionEmpty = true;
  if (roomData['1'] != null) {
    multipleRoomSelectionEmpty = false;
  }
  if (rooms.length > 0) {
    cartDataEmpty = false;
  }
  if (cartDataEmpty === true && multipleRoomSelectionEmpty === true) {
    return true;
  }
  return false;
};

export const selectCurrentRoomText = (props, context) => {
  const selection = props.multipleRoomSelection;
  const allNumericKeys = countAllNumericKeys(selection);
  const nullNumericKeys = countNullNumericKeys(selection);
  const difference = allNumericKeys - nullNumericKeys;
  if (difference === props.distributions.length) {
    return '';
  }
  if (props.distributions.length === 1) {
    return context.t('Select Room');
  }
  return `${context.t('Select Room')} ${0}${props.currentRoomId}`;
};

export const countNullNumericKeys = (obj) => Object.keys(obj).reduce((count, key) => {
  // Usar una variable local en lugar de modificar el parámetro directamente
  let newCount = count;
  if (!Number.isNaN(Number(key)) && obj[key] === null) {
    newCount += 1;
  }
  return newCount;
}, 0);

export const countAllNumericKeys = (obj) => Object.keys(obj).reduce((count, key) => {
  // Usar una variable local en lugar de modificar el parámetro directamente
  let newCount = count;
  if (!Number.isNaN(Number(key))) {
    newCount += 1;
  }
  return newCount;
}, 0);

export const getTotalsDistributionsByCategory = (props) => {
  let totals = null;
  if (props.isInBookingDetailsPage) {
    const distributions = [];
    // eslint-disable-next-line no-unused-vars
    props.editBooking.rooms.forEach((room, index) => {
      distributions.push(room.distribution);
    });
    totals = distributions.reduce((acc, curr) => {
      acc.adl += curr.adults;
      acc.chd += curr.children;
      acc.enf += curr.infants;
      return acc;
    }, { adl: 0, chd: 0, enf: 0 });
  } else if (props.mostrarExtras) {
    totals = props.distributions.reduce((acc, curr) => {
      acc.adl += curr.adl;
      acc.chd += curr.chd;
      acc.enf += curr.enf;
      return acc;
    }, { adl: 0, chd: 0, enf: 0 });
  } else {
    totals = props.distributions.reduce((acc, curr) => {
      acc.adl += curr.adl;
      acc.chd += curr.chd;
      acc.enf += curr.enf;
      return acc;
    }, { adl: 0, chd: 0, enf: 0 });
  }
  return totals; // Añadido para devolver el resultado
};

export const getDiscountPercentageFromTwoAmounts = (props) => {
  const totalAmounts = FinalRoomsAmount(props);
  const amount1 = getTwoDecimalValue(totalAmounts.totalAmountBefore - totalAmounts.totalAmountExtras);
  const amount2 = getTwoDecimalValue(totalAmounts.totalAmount - totalAmounts.totalAmountExtras);
  const descuento = getTwoDecimalValue(amount1 - amount2);
  const porcentajeDescuento = getTwoDecimalValue((descuento / amount1) * 100);
  return Math.floor(porcentajeDescuento);
};

export const getDifferenceFromTwoAmounts = (props) => {
  const totalAmounts = FinalRoomsAmount(props);
  const amount1 = getTwoDecimalValue(totalAmounts.totalAmountBefore - totalAmounts.totalAmountExtras);
  const amount2 = getTwoDecimalValue(totalAmounts.totalAmount - totalAmounts.totalAmountExtras);
  const descuento = getTwoDecimalValue(amount1 - amount2);
  return descuento;
};

export const FinalRoomsAmount = (props, forced_currency = null, mostrarSinImpuestos = true) => {
  // Cuando es mostrarSinImpuestos true nos devuelve el precio total restándole los impuestos
  // Si mandamos mostrarSinImpuestos en false, nos devuelve el precio total
  const currency_to_use = forced_currency != null
    ? forced_currency : props.isInBookingDetailsPage ? props.editBooking.currency.code : props.currency.code;
  const roomData = props.multipleRoomSelection;
  // Iterar sobre las claves numéricas y encontrar el primer cuarto seleccionado
  const foundKey = Object.keys(roomData).find((k) => roomData[k] && roomData[k].rateCode);
  if (foundKey !== undefined) {
    rateCodePrimeroSeleccionado = roomData[foundKey].rateCode;
    boardCodePrimeroSeleccionado = roomData[foundKey].boardCode;
  } else {
    rateCodePrimeroSeleccionado = null;
    boardCodePrimeroSeleccionado = null;
  }

  // Buscar el rate correspondiente al rateCode encontrado
  /*let rateNamePrimeroSeleccionado = null;
  if (rateCodePrimeroSeleccionado) {
    const { rates } = roomData['1'].room; // Accediendo a los rates del primer cuarto seleccionado
    for (let i = 0; i < rates.length; i++) {
      if (rates[i].code === rateCodePrimeroSeleccionado) {
        rateNamePrimeroSeleccionado = rates[i].name;
        break;
      }
    }
  }*/
  /*let boardNamePrimeroSeleccionado = null;
  if (rateCodePrimeroSeleccionado) {
    const { rates } = roomData['1'].room; // Accediendo a los rates del primer cuarto seleccionado
    for (let i = 0; i < rates.length; i++) {
      if (rates[i].code === rateCodePrimeroSeleccionado) {
        const { boards } = rates[i];
        for (let j = 0; j < boards.length; j++) {
          if (boards[j].code === boardCodePrimeroSeleccionado) {
            boardNamePrimeroSeleccionado = getLangValue(boards[j], props.lang, 'name');
          }
        }
        break;
      }
    }
  }*/

  const totalAmounts = {
    totalAmount: 0,
    totalAmountBefore: 0,
    totalAmountExtras: 0,
    totalTaxes: 0,
    totalTaxesBefore: 0,
  };

  let rooms = null;
  if (props.isInBookingDetailsPage) {
    rooms = props.editBooking.rooms;
    // eslint-disable-next-line no-unused-vars
    rooms.forEach((room, index) => {
      /*let totalRoomExtras = 0;
      totalRoomExtras = getTotalAmountExtrasForEditedBooking(props, index);
      totalAmounts.totalAmountExtras += totalRoomExtras;*/
      // El costo de los extras ya viene incluido en el costo de la reserva ya hecha
      // Por eso no necesitamos setearlos en esta parte cuando props.isInBookingDetailsPage
      totalAmounts.totalAmount += Math.round(room.amount * 100) / 100;
    });
  } else if (props.mostrarExtras === false) {
    rooms = props.multipleRoomSelection;
    Object.keys(rooms).filter((key) => !Number.isNaN(Number(key))).forEach((key) => {
      if (rooms[key] != null) {
        let totalRoomExtras = 0;
        if (props.mostrarExtras === true) {
          totalRoomExtras = getTotalAmountExtras(props, key, currency_to_use);
          totalAmounts.totalAmountExtras += totalRoomExtras;
        }
        const { rates } = rooms[key].room; // Accediendo a los rates del primer cuarto seleccionado
        for (let i = 0; i < rates.length; i++) {
          if (rates[i].code === rateCodePrimeroSeleccionado) {
            const { boards } = rates[i];
            for (let j = 0; j < boards.length; j++) {
              if (boards[j].code === boardCodePrimeroSeleccionado) {
                totalAmounts.totalAmount += Math.round(boards[j].amount[currency_to_use].amount * 100) / 100;
                totalAmounts.totalAmountBefore += Math.round(boards[j].amount[currency_to_use].amount_before * 100)
                / 100;
                break;
              }
            }
            break;
          }
        }
      }
    });
  } else {
    rooms = props.cart.cartHotel.rooms;

    rooms.forEach((room, index) => {
      let totalRoomExtras = 0;
      totalRoomExtras = getTotalAmountExtras(props, index + 1, currency_to_use);
      totalAmounts.totalAmountExtras += totalRoomExtras;
      totalAmounts.totalAmount += Math.round(room.amount[currency_to_use] * 100) / 100;
      totalAmounts.totalAmountBefore += Math.round(room.amount_before[currency_to_use] * 100) / 100;
    });
  }

  totalAmounts.totalAmountExtras = Math.round(totalAmounts.totalAmountExtras * 100) / 100;
  //totalAmounts.totalAmount += totalAmounts.totalAmountExtras;
  //totalAmounts.totalAmountBefore += totalAmounts.totalAmountExtras;
  totalAmounts.totalAmount = Math.round(totalAmounts.totalAmount * 100) / 100;
  totalAmounts.totalAmountBefore = Math.round(totalAmounts.totalAmountBefore * 100) / 100;

  // Para mostrar tarifas sin impuestos
  totalAmounts.totalTaxes = totalAmounts.totalAmount * (props.hotel.percentage_total_taxes / 100);
  totalAmounts.totalTaxesBefore = totalAmounts.totalAmountBefore * (props.hotel.percentage_total_taxes / 100);

  if (props.hotel != null && mostrarSinImpuestos === true) {
    if (props.hotel.percentage_total_taxes > 0) {
      totalAmounts.totalAmount -= totalAmounts.totalTaxes;
      totalAmounts.totalAmountBefore -= totalAmounts.totalTaxesBefore;
    }
  }

  // Cuando es SA y agentSell es true, el agente puede decidir usar la tarifa pública o la tarifa neta
  if (props.agentCode !== '' && props.agentSell === 'true'
    && props.rateType === 'NET_RATE' && props.saNetRatepercentage > 0 && mostrarSinImpuestos === true) {
    // Acá las cantidades son netas porque traemos mostrarSinImpuestos=true, entonces a las cantidades se calculan así:
    // La cantidad menos la cantidad por el porcentaje de saNetRate
    totalAmounts.totalAmount -= (totalAmounts.totalAmount * (props.saNetRatepercentage / 100));
    totalAmounts.totalAmountBefore -= (totalAmounts.totalAmountBefore * (props.saNetRatepercentage / 100));
  }
  if (props.agentCode !== '' && props.agentSell === 'true'
    && props.rateType === 'NET_RATE' && props.saNetRatepercentage > 0 && mostrarSinImpuestos === false) {
    // Acá las cantidades llevan impuestos porque traemos mostrarSinImpuestos=false, entonces a las cantidades
    // se calculan así: La cantidad menos el costo sin impuestos por el porcentaje de saNetRate
    //const totalAmountWithoutTaxesIncluded = totalAmounts.totalAmount - totalAmounts.totalTaxes;
    //const totalAmountBeforeWithoutTaxesIncluded = totalAmounts.totalAmountBefore - totalAmounts.totalTaxesBefore;
    totalAmounts.totalAmount -= (totalAmounts.totalAmount * (props.saNetRatepercentage / 100));
    totalAmounts.totalAmountBefore -= (totalAmounts.totalAmountBefore * (props.saNetRatepercentage / 100));
  }
  return totalAmounts;
};

const getTwoDecimalValue = (amount) => Math.round(amount * 100) / 100;

export const getTotalAmountExtras = (props, roomId, forced_currency = null) => {
  const currency_to_use = forced_currency != null ? forced_currency : props.currency.code;
  const roomsInCart = props.cart.cartHotel.rooms;
  let totalAmountExtras = 0;

  // Solo iterar sobre la habitación con roomId
  const room = roomsInCart[roomId - 1];
  //Le restamos 1 a roomId porque estamos accediendo al índice de una lista
  //Los índices en las listas empiezan en 0
  //Y los roomIds empiezan en 1
  if (room) {
    for (let j = 0; j < room.extras.length; j++) {
      totalAmountExtras += room.extras[j].prices[currency_to_use].amount;
    }
  }

  return totalAmountExtras;
};

export const getTotalAmountExtrasForEditedBooking = (props, roomIndex) => {
  let totalRoomExtras = 0;
  // eslint-disable-next-line no-unused-vars
  props.editBooking.rooms[roomIndex].extras.forEach((extra, index) => {
    totalRoomExtras += extra.amount * extra.quantity;
  });
  return totalRoomExtras;
};

export const getUpperLimitForLoyaltyUserRate = (props, bookingAmount) => {
  // Esta función es usada por LoyaltyUserRate y sirve para determinar el descuento máximo que puede
  // tener un cuarto para poder mostrarlo en ese widget. Ahí todavía no hay nada seleccionado
  // por eso el costo del cuarto lo pasamos por parámetro
  let upperLimit = props.maxCoinsToApply;
  if (props.new_member === true && props.new_member_discount_percentage_activated === true) {
    const coinsATomarEnCuenta = getCoinsMaximosATomarEnCuentaForLoyaltyUserRate(props, bookingAmount);
    const currency_to_use = props.hotel.city.zone.country.iso_code === 'MX' ? 'USD' : 'EUR';
    upperLimit = coinsATomarEnCuenta
    - bookingAmount[currency_to_use].amount * (props.new_member_discount_percentage / 100);
  }
  if (upperLimit >= props.maxCoinsToApply || upperLimit < 0) {
    return props.maxCoinsToApply;
  }
  return Math.round(upperLimit);
};

export const getCoinsMaximosATomarEnCuentaForLoyaltyUserRate = (props, bookingAmount) => {
  if (props.memberInfo == null) {
    return 0;
  }
  let coinsATomarEnCuenta = 0;
  //No se pueden tomar en cuenta todos los coins, sino sólo hasta la cantidad máxima permitida según el maxDiscounPercentage
  const currency_to_use = props.hotel.city.zone.country.iso_code === 'MX' ? 'USD' : 'EUR';
  if (props.memberInfo.availableCoins > (Math.round(bookingAmount[currency_to_use].amount
    * (props.maxPercentUsage / 100)))) {
    coinsATomarEnCuenta = (Math.round(bookingAmount[currency_to_use].amount
    * (props.maxPercentUsage / 100)));
  } else {
    coinsATomarEnCuenta = props.memberInfo.availableCoins;
  }
  return coinsATomarEnCuenta;
};
